export const getPathname = state => state.router.location.pathname;
export const getJourneyData = state => state.journeyData;
export const getJourneyId = state => state.journey.journeyId;
export const getSubmodules = state => state.journey.submodules;
export const getPages = state => state.pages;
